import { useWatchViewport, ViewportBoundsFlexible } from "../ViewportProvider";

export const leftNavViewportTypes = ["s", "m", "l"] as const;

/**
 * Type of the viewport
 */
export type LeftNavViewportType = typeof leftNavViewportTypes[number];

// Sizes for a whole new viewport for LeftNav to work off of.
// See our design figma for a breakdown of our viewport for LeftNav
// https://www.figma.com/file/DqgCkKLMCh0BxCcc9KnC7O/%5BTwo-UI%5D-AMC-Component-Library?type=design&node-id=20516-0&mode=design&t=p2Sa4XeU5G1sOLpF-0
export const viewportLeftNavWidthMin: ViewportBoundsFlexible<LeftNavViewportType> = {
    s: 0,
    m: 548,
    l: 1284,
};

export const viewportLeftNavWidthMax: ViewportBoundsFlexible<LeftNavViewportType> = {
    s: viewportLeftNavWidthMin.m - 1,
    m: viewportLeftNavWidthMin.l - 1,
    l: Number.MAX_SAFE_INTEGER,
};

export const useLeftNavViewportProvider: () => LeftNavViewportType = () => {
    return useWatchViewport<LeftNavViewportType>(
        leftNavViewportTypes,
        viewportLeftNavWidthMin,
        viewportLeftNavWidthMax,
    );
};
